<template>
	<div class="CellAdd">
		<div><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/></div>
		<div class="col-md-12" v-show="bShowFilter"><ReFilter :masAllFilterParams="masAllFilterParams" v-model="objGetParams" v-on:filterapply="OnFilterApply"/></div>
		<!-- readonly: {{ canNotEdit}} <span v-on:click="canNotEdit=!canNotEdit">переключить</span> -->
		<div v-if=(!canNotEdit)>
			<h4 class="text-center text-uppercase" v-if="isEdit==false">Добавление ячейки</h4>
			<h4 class="text-center text-uppercase" v-else>Редактирование ячейки</h4>
			<h4 class="text-center">Выделите область на карте</h4>
		</div>
		<card >
			<div v-if=(!canNotEdit)>
				<h5 v-if="isEdit==false"><i class="tim-icons icon-send text-success mr-3"></i>Добавление ячейки</h5>
				<h5 v-else><i class="tim-icons icon-send text-success mr-3"></i>Редактирование ячейки</h5>
			</div>
			<form action="" ref="form">
				<div class="row justify-content-between align-items-center" v-if=(!canNotEdit)>
					<div class="col-md mb-3">
						<input type="text" placeholder="Название ячейки" class="form-control" v-model="objCell.cellName">
					</div>
					
					<div class="d-flex px-3 mb-3">
						<button v-if="isEdit==false" class="btn btn-success btn-simple mr-3" type="button" @click="createCell()">Создать</button>
						<button v-else class="btn btn-success btn-simple mr-3" type="button" @click="updCell()">Сохранить</button>
						<button class="btn btn-danger btn-simple" type="button" @click="cancelCell()">Отменить</button>
					</div>
				</div>
				<div class="cellmap-wrapper">				
					<div class="cellmap"> 
						<re-cell-map-editor ref="cellEditor" :cells="masCellAdd" :readonly="canNotEdit" v-model="polygon" ></re-cell-map-editor>
					</div>
				</div>
			</form>
			
		</card>
		<card class="CellAdd-table">
			<el-table 
				:data="masCellAdd" 
				:highlight-current-row="false" 
				:cell-style="{height:'100px'}" 
				style="width: 100%;" 
				class="el-table--scrollable-x">
				<el-table-column
					sortable
					width="80"
					label="ИД"
					property="id"
				></el-table-column>
				<el-table-column
					sortable
					min-width="180"
					label="Название ячейки"
					property="cellName"
				>
					<!--template slot-scope="scope">
						<el-popover trigger="hover" placement="top" :key="scope.row.cellName" >
							<div>ФИО ответственного: scope.row.agentName {{  }}</div>
							<div>Класс жилья: scope.row.masClasses.value {{  }}</div>
							<div>Тип жилья: scope.row.houseType {{  }}</div>
							<div>Комнатность: scope.row.houseRooms {{  }}</div>

							<div slot="reference"  class="name-wrapper cellName">
								<div>{{scope.row.cellName }}</div>
							</div>
						</el-popover>
					</!--template-->
				</el-table-column>
				<el-table-column
					min-width="180"
					label="На карте"
					property="cellStyle"
				>
					<template v-slot="scope">	
						<base-button class="ml-3 btn btn-simple btn-primary" @click="showThisCell(scope.$index, scope.row)">
							<i class="tim-icons icon-square-pin"></i>
							Показать на карте
						</base-button>											
					</template>
				</el-table-column>
				<el-table-column
					min-width="240"
					height="100"
					label="Координаты ячейки"
					property="cellValues"
				>
					<!--template slot-scope="scope">
						<div slot="reference"  class="name-wrapper cellValues">
							<div>{{scope.row.cellValues }}</div>
						</div>
					</!--template-->
				</el-table-column>
				<el-table-column
					width="80"
					label=""
					v-if=(!canNotEdit)
				>	
					<template v-slot="scope">						
						<el-tooltip content="Редактировать соту" placement="top">
							<el-button class="no-border my-0">
								<base-button  class="ml-3 btn btn-icon btn-simple btn-primary" @click="editCell(scope.$index, scope.row)">
									<i class="tim-icons icon-pencil"></i>
								</base-button>											
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<!--el-table-column
					min-width="80"
					label="agent_id"
					property="agent_id"
				>	
				</el-table-column-->
				<el-table-column
					width="110"
					label="Действие"
					align="right"      
					v-if=(!canNotEdit)              	
				>
					<template v-slot="scope">						
						<ReActionBtns :masActions="masActions[scope.$index]"/>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
	</div>	
</template>
<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
// import { BaseSwitch } from 'src/components';
import { Table, TableColumn, Tooltip, Button, Popover } from 'element-ui';
import ReCellMapEditor from 'src/our_components/ReCellMapEditor.vue';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'celladd-page',
	components: {
		[Table.name]: Table,
    	[TableColumn.name]: TableColumn,
		[Tooltip.name]: Tooltip,	
		[Button.name]: Button,
		[Popover.name]: Popover,
		// BaseSwitch,
		ReCellMapEditor,
		ReActionBtns,
		ReFilterBtn,
		ReFilter,	
		Pagination
	},
	props: {
		
	},
	data() {
		return {
			curCell: [],
			RaspredData: [],
			masCellAdd: [],
			objCell: {},
			polygon:'[]',
			masActions:[],	
			bShowFilter: false,
			isEdit: false,
			canNotEdit: true,
			masAllFilterParams: this.currentFilterConfig(),
			masObjects_total: 0,
			count2page: 10,
			objGetParams:{},
		};
	},
	methods: {
		currentFilterConfig(){
			this.$GVO.ApiCall('MAP_CELLS.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('MAP_CELLS.GET',{flt:{...{'list':true}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.readonly == 1){
						this.canNotEdit = true;
					}else {this.canNotEdit = false;}
					
					if(objApi.data.length > 0){
						this.masObjects_total = objApi.countpage;
						this.masCellAdd = objApi.data;

						this.masActions = [];
						for (let i = 0; i < this.masCellAdd.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.masCellAdd[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_ACT_RESTRICTIONS',apiParam:{obj:'MAP_CELLS',flt:{id:this.masCellAdd[i].id}}},
								},
							]);
						}
						// console.log(this.canNotEdit);
						
					}else {
						this.masCellAdd = [];
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		createCell() {
			this.$GVO.ApiCall('INS', {obj:'MAP_CELLS', iData:{
					id: this.objCell.id,
					cellName: this.objCell.cellName,
					act: this.objCell.cellAct,
					cellValues: this.polygon,		
					agent_id: this.agent_id,					
					}
				}
			)
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masCellAdd = objApi.data;			
					}
					this.getApiData();					
					this.objCell.cellName = '';
					this.polygon = '[]';
					this.$refs.cellEditor.startEdit();				
				}else {
					this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание и редактирование сот.</p>')
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		editCell(index, row){
			// console.log(index, row);
				this.polygon = row.cellValues;
				this.isEdit = true;
				this.objCell.cellName = row.cellName;
				this.objCell.id = row.id;
				this.$refs.cellEditor.startEdit(true);
				this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
		},
		cancelCell(){
			this.polygon = '';
			this.isEdit = false;
			this.objCell.cellName = '';
			this.objCell.id = '';
		},
		updCell() {
			this.cellName = this.objCell.cellName;
			this.cellValues = this.polygon;
			this.id = this.objCell.id;
			// console.log(this.cellName + ' - ' + this.cellValues + ' - ' + this.id);

			this.$GVO.ApiCall('UPD', {obj:'MAP_CELLS',flt:{id: this.id}, uData:{
					cellName: this.cellName,
					cellValues: this.cellValues,		
					}
				}
			)
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masCellAdd = objApi.data;			
					}
					this.getApiData();					
					this.objCell.cellName = '';
					this.polygon = '[]';
					this.isEdit = false;
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		showThisCell(index, row){
			//При клике на строке таблицы сот (на кнопку), стирать на карте все ячейки и отображать только текущую.
			//по строке потом будет ховер с данными, поэтому при клике по кнопке выделяем цветом полигон на карте

			this.objCell.id = row.id;
			this.objCell.cellValues = row.cellValues;
			
			// console.log(this.objCell.cellValues);

			for (let i = 0; i < this.masCellAdd.length; i++) {
				if(this.masCellAdd[i].id == this.objCell.id){
					this.masCellAdd[i].cellStyle = '#FF8D72'; 
					
					this.$refs.cellEditor.drawCells();
					this.$refs.cellEditor.focus(this.masCellAdd[i].cellValues);
					this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
				
				} else {
					this.masCellAdd[i].cellStyle = ''; 
				}
			}
		},
		formatter (row, column) {
			return row.id;
		},
		// getRaspredData(){
		// 	this.objGetParams = this.$GVO.GetAllGet();
		// 	let filter = {};
		// 	if (!this.$GVO.isEmpty(this.objGetParams)) {
		// 		//console.log('getClients',this.objGetParams);
		// 		filter = this.objGetParams;
		// 	}
		// 	this.$GVO.ApiCall('CELLS_STAFF.GET',{flt:{...{act:1}, ...filter}})
		// 	.then((objApi) => {
		// 		if(objApi.success === true){
		// 		if(objApi.data.length > 0){
		// 			this.RaspredData = objApi.data;
		// 		}
		// 		}
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		
	},
	watch:{
		polygon(val){
		}
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
		// this.getRaspredData();
	}
};
</script>
<style>
.CellAdd .cellmap-wrapper {
	position: relative;
	width: 100%;
	height:  100%;
	padding: 0 20px;
}
.CellAdd .btn-cellmap {
	position: absolute;
	right: 110px;
	top: 5px;
}
.filter{
	padding: 15px;
	border: 1px solid #01B0E0;
	border-radius: 30px;
}

.CellAdd-table .cellName, .CellAdd-table button {
	word-break: break-word!important;
}

.CellAdd-table .cell {
	max-height: 70px!important;
}

</style>
